// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
            <path
                d="M21.875,0 L2.625,0 C1.17578125,0 0,1.17578125 0,2.625 L0,21.875 C0,23.3242188 1.17578125,24.5 2.625,24.5 L21.875,24.5 C23.3242188,24.5 24.5,23.3242188 24.5,21.875 L24.5,2.625 C24.5,1.17578125 23.3242188,0 21.875,0 Z M19.2007816,8.68437433 C19.2117198,8.83750033 19.2117198,8.99609375 19.2117198,9.14921892 C19.2117198,13.890625 15.6023448,19.3539076 9.00703192,19.3539076 C6.97265708,19.3539076 5.08593833,18.7632833 3.50000083,17.7460954 C3.78984475,17.7789083 4.06875134,17.7898448 4.36406434,17.7898448 C6.04297042,17.7898448 7.58515775,17.2210951 8.8156265,16.2585948 C7.24062634,16.2257819 5.917189,15.1921885 5.46328259,13.7703135 C6.01562667,13.8523448 6.51328325,13.8523448 7.08203375,13.7046878 C5.44140875,13.3710937 4.21094,11.9273441 4.21094,10.1828132 L4.21094,10.139063 C4.68672109,10.4070314 5.24453425,10.5710939 5.82969034,10.5929694 C4.83046687,9.92831802 4.23085034,8.80711746 4.2328155,7.60703158 C4.2328155,6.93984509 4.40781534,6.32734442 4.71953475,5.796875 C6.48594117,7.97343683 9.13828492,9.39531267 12.1132846,9.54843783 C11.6046907,7.11484408 13.4257846,5.140625 15.6132838,5.140625 C16.6468772,5.140625 17.5765647,5.57265759 18.2328147,6.27265692 C19.042189,6.11953259 19.8187522,5.81875134 20.507815,5.40859509 C20.2398466,6.23984408 19.6765643,6.93984509 18.9328157,7.3828125 C19.6546913,7.30625033 20.3546907,7.10390592 21.0000008,6.82499933 C20.5132841,7.54140759 19.9007834,8.17578125 19.2007841,8.68437433 L19.2007816,8.68437433 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(Twitter);
